export default {
	searchParams: SEARCH_PARAMS(),
	partList: [],
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		partNo: '',
		partNoInput: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
